"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iWorksiteDiaryJob = void 0;
const t = require("io-ts");
const Revision = require("./worksiteDiaryJobRevision");
const _iWorksiteDiaryJob = t.intersection([
    t.interface({
        name: t.string,
        new_revision: Revision.iWorksiteDiaryJobRevision
    }),
    t.partial({
        id: t.number,
        job_uuid: t.string,
    })
]);
exports.iWorksiteDiaryJob = t.clean(_iWorksiteDiaryJob);
//# sourceMappingURL=worksiteDiaryJob.js.map